/* Nhiều đơn vị: đơn vị đang làm việc (nhớ trong trình duyệt) và danh sách đơn vị. Mọi yêu cầu gửi lên CSDL kèm header
   `x-company-id` để dữ liệu tự tách theo đơn vị (xem supabase/migrations/0011_companies.sql). */
import { useCallback, useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { getCompany, setCompanyRaw, useCompanyId } from './companyState';
import { useRows } from './data';

export { getCompany, setCompanyRaw, useCompanyId };

export interface Company { id: string; short: string; sortOrder: number }

/** Danh sách đơn vị (đơn vị chính luôn đứng đầu). */
export function useCompanies() {
  const q = useRows<Company>('companies', { order: 'sort_order' });
  const list = useMemo(() => {
    const l = [...(q.data ?? [])].sort((a, b) => (a.id === 'main' ? -1 : b.id === 'main' ? 1 : a.sortOrder - b.sortOrder || a.id.localeCompare(b.id)));
    return l.some(c => c.id === 'main') ? l : [{ id: 'main', short: '', sortOrder: 0 }, ...l];
  }, [q.data]);
  return { ...q, list };
}

/** Tên hiển thị của đơn vị: tên viết tắt, không có thì "Đơn vị chính" / "Đơn vị". */
export const coLabel = (list: Company[], id: string | null | undefined): string => {
  const c = list.find(x => x.id === (id || 'main'));
  if (!c) return '(đã xoá)';
  return c.short || (c.id === 'main' ? 'Đơn vị chính' : 'Đơn vị');
};

/** Đơn vị nào người dùng được làm việc: danh sách `cos` rỗng (hoặc quản trị) = tất cả. */
export const coAllowed = (me: { role: string; cos?: string[] } | null | undefined, id: string): boolean => !me || me.role === 'admin' || !(me.cos || []).length || (me.cos || []).includes(id);

/** Chuyển đơn vị đang làm việc: tải lại mọi dữ liệu theo đơn vị mới. */
export function useSwitchCompany() {
  const qc = useQueryClient();
  return useCallback((id: string) => {
    if (id === getCompany()) return;
    setCompanyRaw(id);
    void qc.resetQueries();
  }, [qc]);
}
